import React, { createContext, useContext, useEffect, useState } from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';
export type ColorMode = 'system' | 'light' | 'dark';
interface ThemeContextValue {
  mode: ColorMode;
  resolved: 'light' | 'dark';
  setMode: (mode: ColorMode) => void;
  toggle: () => void;
}
const ThemeContext = createContext<ThemeContextValue | null>(null);
interface ThemeProviderProps {
  initialMode: ColorMode;
  children: React.ReactNode;
}
export function ThemeProvider({
  initialMode,
  children
}: ThemeProviderProps) {
  const [mode, setMode] = useState<ColorMode>(initialMode);
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)');
  const resolved = mode === 'system' ? systemDark ? 'dark' : 'light' : mode;
  useEffect(() => setMode(initialMode), [initialMode]);
  useEffect(() => {
    document.documentElement.classList.toggle('dark', resolved === 'dark');
  }, [resolved]);
  const toggle = () => setMode(resolved === 'dark' ? 'light' : 'dark');
  return <ThemeContext.Provider value={{
    mode,
    resolved,
    setMode,
    toggle
  }} data-id="element-870" data-mp="3r67vnfwtu2u0">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}